import NotificationsApi from "@/api/notificationApi";

export default {
  state: {
    updateCount: undefined
  },
  namespaced: true,

  getters: {
    updateCount: state => state.updateCount
  },
  actions: {
    // Event on new notifications push from
    newNotification: ({ dispatch }) => {
      dispatch("setUpdateCount", new Date());
    },

    setUpdateCount({ commit }, arg) {
      commit("UPDATE_COUNT", arg);
    },

    resetNotifications: ({ commit }) => {
      commit("RESET");
    },

    actionSelect: ({ dispatch }, args) => {
      const notify = args;

      if (notify.Notification.State.toLowerCase() !== "read") {
        dispatch("setStatusRead", [notify.Id]).then(() => {
          if (notify.Notification.Action) {
            window.location.href = notify.Notification.Action;
          }
        });
      } else if (notify.Notification.Action) {
        window.location.href = notify.Notification.Action;
      }
    },

    /*
    async deleteAll({ dispatch, commit, getters, rootGetters }) {
      let api = new NotificationsApi();
      let userId = rootGetters["User/getUser"].Id;

      await api.deleteUserNotifications(userId);

      // Delete ok, update list
      dispatch("resetNotifications").then(() => {
        dispatch("getNotifications", { skip: 0 });
      });
    },
    */

    setStatusRead: ({ rootGetters }, args) => {
      const userId = rootGetters["User/getUser"].Id;
      const notificationsApi = new NotificationsApi();

      new Promise(resolve => {
        resolve(notificationsApi.setStatusRead(userId, args));
      })
        .then(function (responses) {
          // Check errors
          if (!responses) {
            console.error("Error on updating notify in Read status");
          } else if (responses.length > 0) {
            const ok_responses = responses.filter(item => item.status === 204);
            if (!(!!ok_responses && ok_responses.length === args.length)) {
              console.error("Error on updating notify in Read status");
            }
          }
        })
        .catch(function (e) {
          // Error non updating State Read notification
          console.log(e);
        });
    }
  },

  mutations: {
    UPDATE_COUNT: (state, payload) => {
      state.updateCount = payload;
    },
    RESET: state => {
      state.updateCount = undefined;
    }
  }
};
